import { FC, useCallback } from 'react';
import { useField } from 'formik';

import AutocompleteBase, {
  AutocompleteBaseProps,
  Option,
} from 'components/AutocompleteBase';

type Props = AutocompleteBaseProps & {
  name: string;
};

export type AutocompleteProps = Props;
export type AutocompleteOption = Option;

const Autocomplete: FC<Props> = ({ helperText, name, ...props }) => {
  const [field, meta, { setValue }] = useField<Option>(name);
  const hasError = Boolean(meta.touched && meta.error);

  const handleChange = useCallback(
    (_, value) => {
      setValue(value);
    },
    [setValue]
  );

  return (
    <AutocompleteBase
      error={hasError}
      helperText={hasError ? meta.error : helperText}
      {...field}
      {...props}
      onChange={handleChange}
    />
  );
};

export default Autocomplete;
